<!--megamenu section Start-->
<header class="dark loding-header custom-scroll" [ngClass]="url == '/portfolio/portfolio-parallex' || url == '/portfolio/centered-slide' || url == '/portfolio/multiple-carousel' ?'bg-white':''">
    <div class="container">
        <div class="row">
            <div class="col">
                <nav>
                    <a [routerLink]="['/']" title="{{ 'title' | translate }}" class="d-inline-block m-r-auto">
                        <img [src]="logo" alt="EZane Mortage Logo" class="img-fluid brand-logo logo">
                    </a>
                    <app-menu></app-menu>
                </nav>
            </div>
        </div>
    </div>
</header>
<!--megamenu section end-->